import { Strategy } from "../stock-exchange.flow";

class FullStrategy implements Strategy {
  public isMasked() {
    return false;
  }

  public getDummyRates() {
    return undefined;
  }

  public getDummyOutlook() {
    return undefined;
  }

  public showCallToAction() {
    return false;
  }
}

export { FullStrategy };
